import { defineStore } from 'pinia'

const yearlySummaries = {
  2025: {
    totalRevenue: 2184500,
    totalInvoiced: 2430000,
    collectionRate: 89.9,
    overdueAmount: 245500,
    occupiedUnits: 118,
    activeResidents: 124,
  },
  2026: {
    totalRevenue: 864300,
    totalInvoiced: 1015000,
    collectionRate: 85.1,
    overdueAmount: 150700,
    occupiedUnits: 121,
    activeResidents: 128,
  },
}

const monthlyRevenue = {
  2025: [
    { month: 'ม.ค.', invoiced: 195000, collected: 182500 },
    { month: 'ก.พ.', invoiced: 198000, collected: 186000 },
    { month: 'มี.ค.', invoiced: 201000, collected: 189500 },
    { month: 'เม.ย.', invoiced: 202000, collected: 191000 },
    { month: 'พ.ค.', invoiced: 204000, collected: 193500 },
    { month: 'มิ.ย.', invoiced: 202000, collected: 191000 },
    { month: 'ก.ค.', invoiced: 203000, collected: 192000 },
    { month: 'ส.ค.', invoiced: 205000, collected: 194500 },
    { month: 'ก.ย.', invoiced: 206000, collected: 195000 },
    { month: 'ต.ค.', invoiced: 205000, collected: 194000 },
    { month: 'พ.ย.', invoiced: 204000, collected: 192500 },
    { month: 'ธ.ค.', invoiced: 205000, collected: 193000 },
  ],
  2026: [
    { month: 'ม.ค.', invoiced: 210000, collected: 176000 },
    { month: 'ก.พ.', invoiced: 205000, collected: 172500 },
    { month: 'มี.ค.', invoiced: 240000, collected: 184500 },
    { month: 'เม.ย.', invoiced: 180000, collected: 158000 },
    { month: 'พ.ค.', invoiced: 180000, collected: 173300 },
  ],
}

const channelCollections = {
  2025: [
    { label: 'โอนธนาคาร', value: 980000, color: 'primary' },
    { label: 'QR Payment', value: 640000, color: 'success' },
    { label: 'เงินสด', value: 340000, color: 'warning' },
    { label: 'บัตรเครดิต', value: 224500, color: 'info' },
  ],
  2026: [
    { label: 'โอนธนาคาร', value: 372000, color: 'primary' },
    { label: 'QR Payment', value: 258300, color: 'success' },
    { label: 'เงินสด', value: 148000, color: 'warning' },
    { label: 'บัตรเครดิต', value: 86000, color: 'info' },
  ],
}

const agingSummary = {
  2025: [
    { label: '1 - 30 วัน', amount: 78000, cases: 12, color: 'warning' },
    { label: '31 - 60 วัน', amount: 64000, cases: 8, color: 'danger' },
    { label: '61 - 90 วัน', amount: 42000, cases: 4, color: 'danger' },
    { label: 'มากกว่า 90 วัน', amount: 61500, cases: 3, color: 'dark' },
  ],
  2026: [
    { label: '1 - 30 วัน', amount: 51200, cases: 9, color: 'warning' },
    { label: '31 - 60 วัน', amount: 38400, cases: 5, color: 'danger' },
    { label: '61 - 90 วัน', amount: 27000, cases: 3, color: 'danger' },
    { label: 'มากกว่า 90 วัน', amount: 34100, cases: 2, color: 'dark' },
  ],
}

const reportHighlights = {
  2025: [
    { id: 1, title: 'อัตราการจัดเก็บเฉลี่ยสูงขึ้น', description: 'อัตราการจัดเก็บเฉลี่ยทั้งปีอยู่ที่ 89.9% สูงขึ้นจากปีก่อน', type: 'success' },
    { id: 2, title: 'ยอดค้างชำระกลุ่มเกิน 90 วันลดลง', description: 'จำนวนเคสลดลงเหลือ 3 เคสจากมาตรการติดตามรายเดือน', type: 'primary' },
    { id: 3, title: 'QR Payment เติบโตต่อเนื่อง', description: 'สัดส่วนการชำระผ่าน QR เพิ่มขึ้นเป็นช่องทางอันดับ 2 ของโครงการ', type: 'info' },
  ],
  2026: [
    { id: 1, title: 'ยอดออกบิลไตรมาสแรกสูงกว่าปีที่แล้ว', description: 'จากจำนวนยูนิตใช้งานและอัตราค่าส่วนกลางที่ปรับปรุงใหม่', type: 'primary' },
    { id: 2, title: 'ยังมีเคสค้างชำระเร่งด่วน 5 เคส', description: 'ควรติดตามกลุ่มที่มีอายุหนี้มากกว่า 60 วันอย่างใกล้ชิด', type: 'danger' },
    { id: 3, title: 'รายรับผ่านบัตรเครดิตเพิ่มขึ้น', description: 'ลูกบ้านเริ่มใช้ช่องทางออนไลน์และบัตรเครดิตมากขึ้นในปี 2026', type: 'success' },
  ],
}

export const useReportStore = defineStore('report', {
  state: () => ({
    filters: {
      year: '2026',
      project: 'all',
    },
    projectOptions: [
      { label: 'ทุกโครงการ', value: 'all' },
      { label: 'Central Fee Residence', value: 'central-fee-residence' },
      { label: 'Central Fee Tower', value: 'central-fee-tower' },
    ],
    years: ['2026', '2025'],
    yearlySummaries,
    monthlyRevenue,
    channelCollections,
    agingSummary,
    reportHighlights,
  }),

  getters: {
    selectedYear: (state) => state.filters.year,

    summary: (state) => state.yearlySummaries[state.filters.year] || {
      totalRevenue: 0,
      totalInvoiced: 0,
      collectionRate: 0,
      overdueAmount: 0,
      occupiedUnits: 0,
      activeResidents: 0,
    },

    revenueTrend: (state) => state.monthlyRevenue[state.filters.year] || [],
    collectionByChannel: (state) => state.channelCollections[state.filters.year] || [],
    arrearsAging: (state) => state.agingSummary[state.filters.year] || [],
    highlights: (state) => state.reportHighlights[state.filters.year] || [],

    collectionGap: (state) => {
      const summary = state.yearlySummaries[state.filters.year]
      if (!summary) return 0
      return Math.max(summary.totalInvoiced - summary.totalRevenue, 0)
    },
  },

  actions: {
    setYear(value) {
      this.filters.year = value
    },
    setProject(value) {
      this.filters.project = value
    },
  },
})

